import React, { useCallback } from 'react';
import { Form, Switch, Tag } from 'antd';

type FeatureStatusInputProps = {
    name: string | string[];
    id: string;
    isDetailMode: boolean | undefined;
    enabled: boolean | undefined;
    isFeatureDisabled?: boolean;
    onChange?: (val: boolean) => void;
    enableControls?: boolean;
};

const FeatureStatusInput: React.FC<FeatureStatusInputProps> = ({
    name,
    id,
    isDetailMode,
    enabled,
    isFeatureDisabled,
    onChange,
    enableControls,
}: FeatureStatusInputProps) => {
    return (
        <Form.Item name={name} id={id} valuePropName="checked" className="m-0">
            {isDetailMode ? (
                <span className="ant-form-text text-secondary">
                    <Tag color={enabled ? 'blue' : 'default'}>{enabled ? 'ENABLED' : 'DISABLED'}</Tag>
                </span>
            ) : (
                <Switch
                    title={isFeatureDisabled ? 'Enable feature' : 'Disable feature'}
                    checkedChildren="Enabled"
                    unCheckedChildren="Disabled"
                    onChange={onChange}
                    disabled={enableControls === false}
                />
            )}
        </Form.Item>
    );
};

export default FeatureStatusInput;
